import React, { useContext } from "react";
import Trash from "../../assets/imgs/trash.svg";
import Pagamento from "../../assets/imgs/pagamento.svg";
import "./CarrinhoContent.css";
import { CarrinhoContext } from "../../services/context/CarrinhoContext";
import { Link } from "react-router-dom";

function CarrinhoContent({ onCloseCarrinho }) {
  const main = process.env.REACT_APP_MAIN;
  const API_URL = process.env.REACT_APP_API;
  const {
    carrinho,
    modificarQuantidade,
    removerItem,
    limparCarrinho,
    valorTotal,
    getFreteInfo,
  } = useContext(CarrinhoContext);

  const freteInfo = getFreteInfo() || {};

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scroll behavior
    });
  };

  const calculateItemTotal = (preco, quantidade) => {
    const precoSeguro = parseFloat(preco) || 0;
    const quantidadeSegura = parseInt(quantidade) || 1;
    return precoSeguro * quantidadeSegura;
  };

  const handleQuantidadeChange = (itemId, formato, novaQuantidade) => {
    if (novaQuantidade >= 1 && novaQuantidade <= 99) {
      modificarQuantidade(itemId, formato, novaQuantidade);
    }
  };

  return (
    <div className="carrinho-content-container">
      <h2 className="main-title">Seu Carrinho</h2>

      {carrinho.length === 0 ? (
        <div className="d-flex flex-column align-items-center justify-content-center mt-5">
          <img
            src="https://cdn-icons-png.flaticon.com/512/2038/2038854.png"
            alt="Carrinho vazio"
            className="mb-3"
            style={{ maxWidth: '150px' }}
          />
          <h3 className="text-muted mb-2">Seu carrinho está vazio!</h3>
          <p className="text-muted text-center">
            Parece que você ainda não adicionou nenhum produto.<br />
            Que tal explorar a loja e encontrar algo interessante?
          </p>

        </div>
      ) : (
        <>
          <div className="carrinho-content carrinho-sidebar">
            {carrinho.map((item) => {
              if (!item || !item.id) return null;
              
              return (
              <div key={`${item.id}-${item.formato}`}>
                <div className="product-flex">
                  <div className="carrinho-item-img">
                    <img
                      src={`${API_URL}public/${item.image || ''}`}
                      alt="productImage"
                    ></img>
                  </div>
                  <div className="item">
                    <div className="product-flex">
                      <div>
                        <strong>{item.titulo || 'Produto sem título'}</strong>
                        {/* O presente e repetido no carrinho de proposito: entre
                            escolher o formato e pagar existe a tela onde a pessoa
                            reconsidera, e e ali que o "ja vem com o e-book" segura
                            a compra do impresso. `ebook_de_brinde` viaja no item
                            desde o PrecoCard (unico lugar que vende impresso). */}
                        <div style={{ fontSize: "14px", color: "#666", marginTop: "5px" }}>
                          Formato: {item.formato === 'fisico' ? 'Físico' : 'E-book'}
                          {item.formato === 'fisico' && item.ebook_de_brinde && (
                            <span style={{ color: "#b8860b", fontWeight: 600 }}>
                              {' · e-book para ler no site incluso'}
                            </span>
                          )}
                        </div>
                        <div style={{ fontSize: "14px", color: "#666" }}>
                          Preço unitário: R$ {(parseFloat(item.preco) || 0).toFixed(2)}
                        </div>
                      </div>

                      <div>
                        <div style={{ marginBottom: "10px" }}>
                          <strong>Subtotal: R$ {calculateItemTotal(item.preco || 0, item.quantidade || 1).toFixed(2)}</strong>
                        </div>
                        
                        {/* Controles de quantidade - só para livros físicos */}
                        {item.formato === 'fisico' ? (
                          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                            <span style={{ fontSize: "14px", fontWeight: "bold" }}>Qtd:</span>
                            <button
                              onClick={() => handleQuantidadeChange(item.id, item.formato, (item.quantidade || 1) - 1)}
                              disabled={(item.quantidade || 1) <= 1}
                              style={{
                                width: "30px",
                                height: "30px",
                                border: "1px solid #FA7F08",
                                backgroundColor: (item.quantidade || 1) <= 1 ? "#f0f0f0" : "white",
                                color: (item.quantidade || 1) <= 1 ? "#ccc" : "#FA7F08",
                                borderRadius: "3px",
                                fontSize: "14px",
                                fontWeight: "bold",
                                cursor: (item.quantidade || 1) <= 1 ? "not-allowed" : "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                            >
                              -
                            </button>
                            <span style={{ 
                              minWidth: "30px", 
                              textAlign: "center", 
                              fontSize: "16px", 
                              fontWeight: "bold" 
                            }}>
                              {item.quantidade || 1}
                            </span>
                            <button
                              onClick={() => handleQuantidadeChange(item.id, item.formato, (item.quantidade || 1) + 1)}
                              disabled={(item.quantidade || 1) >= 99}
                              style={{
                                width: "30px",
                                height: "30px",
                                border: "1px solid #FA7F08",
                                backgroundColor: (item.quantidade || 1) >= 99 ? "#f0f0f0" : "white",
                                color: (item.quantidade || 1) >= 99 ? "#ccc" : "#FA7F08",
                                borderRadius: "3px",
                                fontSize: "14px",
                                fontWeight: "bold",
                                cursor: (item.quantidade || 1) >= 99 ? "not-allowed" : "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                            >
                              +
                            </button>
                          </div>
                        ) : (
                          <div style={{ marginBottom: "10px" }}>
                            <span style={{ fontSize: "14px", color: "#666" }}>
                              Quantidade: 1 (E-book)
                            </span>
                          </div>
                        )}

                        <button 
                          onClick={() => removerItem(item.id, item.formato)}
                          style={{
                            backgroundColor: "#dc3545",
                            color: "white",
                            border: "none",
                            padding: "5px 10px",
                            borderRadius: "3px",
                            fontSize: "12px",
                            cursor: "pointer"
                          }}
                        >
                          Remover
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="carrinho-break"></div>
              </div>
              );
            })}
          </div>

          {/* Informações de Frete */}
          {freteInfo.temLivrosFisicos && (
            <div style={{ 
              backgroundColor: "#f8f9fa", 
              padding: "15px", 
              borderRadius: "3px", 
              margin: "15px 0",
              border: "1px solid #dee2e6"
            }}>
              <h4 style={{ margin: "0 0 10px 0", fontSize: "16px", color: "#495057" }}>
                📦 Informações de Frete
              </h4>
              <div style={{ fontSize: "14px", color: "#6c757d" }}>
                <p style={{ margin: "5px 0" }}>
                  <strong>Total de livros físicos:</strong> {freteInfo.totalLivrosFisicos || 0}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Pacotes necessários:</strong> {freteInfo.multiplicador || 1} 
                  <span style={{ fontStyle: "italic", color: "#666", marginLeft: "5px" }}>
                    (cada pacote comporta até 10 livros)
                  </span>
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Modalidade:</strong> {freteInfo.freteInfo?.modalidade || 'Padrão'}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Valor por pacote:</strong> R$ {(freteInfo.freteBase || 0).toFixed(2)}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Valor total do frete:</strong> R$ {(freteInfo.freteTotal || 0).toFixed(2)}
                </p>
                <p style={{ margin: "5px 0", fontStyle: "italic" }}>
                  {freteInfo.explicacao || 'Informações de frete não disponíveis'}
                </p>
                {(freteInfo.multiplicador || 1) > 1 && (
                  <p style={{ 
                    margin: "10px 0 5px 0", 
                    color: "#FA7F08", 
                    fontWeight: "bold",
                    fontSize: "13px"
                  }}>
                    ⚠️ Como você tem mais de 10 livros físicos, o frete é calculado em {freteInfo.multiplicador} pacote(s)
                  </p>
                )}
              </div>
            </div>
          )}

          <div className="carrinho-valores-container">
            <div style={{ fontSize: "16px", marginBottom: "10px" }}>
              <div>Subtotal produtos: R$ {(valorTotal || 0).toFixed(2)}</div>
              {freteInfo.temLivrosFisicos && (
                <div>Frete: R$ {(freteInfo.freteTotal || 0).toFixed(2)}</div>
              )}
              <div style={{ fontWeight: "bold", fontSize: "18px", marginTop: "10px", paddingTop: "10px", borderTop: "1px solid #dee2e6" }}>
                Total: R$ {((valorTotal || 0) + (freteInfo.temLivrosFisicos ? (freteInfo.freteTotal || 0) : 0)).toFixed(2)}
              </div>
            </div>
          </div>

          <div className="btns-carrinho">
            <Link
              to={main + "checkout/"}
                onClick={() => {
                  onCloseCarrinho();
                  scrollToTop();
                }}
              className="main-btn-orange"

            >
              <img className="img-trash" src={Pagamento} alt="" />
              Continuar para pagar
            </Link>
            <button className="main-btn-blue" onClick={limparCarrinho}>
              <img className="img-trash" src={Trash} alt="" />
              Limpar Carrinho
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default CarrinhoContent;
